import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UsersettingsService } from './service/usersettings.service';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Usersetting } from './model/usersetting';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-usersettings',
  templateUrl: './usersettings.component.html',
  styleUrl: './usersettings.component.css'
})
export class UsersettingsComponent implements OnInit {
  usersettings:Usersetting;
  showSpinner:boolean = false;
  updated:boolean = false;
  @ViewChild('closebutton') closebutton:ElementRef;
  constructor(private service:UsersettingsService) { }

  ngOnInit(): void {
    this.usersettings = new Usersetting;
    this.usersettings.personId = JSON.parse(SessionHelper.getPerson()).personId;
    this.usersettings.personlanguage = 'default';
    this.usersettings.created = new Date();
    this.usersettings.createdby = 'admin';
    //Get the user settings
    this.service.getUserSettings(this.usersettings.personId ).pipe(untilDestroyed(this)).subscribe((setting)=>{
      if(setting == null || setting == undefined || !setting.personId){
       
      }else{
       //console.log(setting);
        this.usersettings = setting;
      }
    });

  }
  updateUserSettings(){
    this.showSpinner = true;
    this.service.updateUserSettings(this.usersettings.personId ,this.usersettings).pipe(untilDestroyed(this)).subscribe((resp)=>{
      //OK message
     //console.log(resp);
      if(this.usersettings.personlanguage != 'default'){
        SessionHelper.setLanguage(this.usersettings.personlanguage);
      }
      //close the modal
      this.closebutton.nativeElement.click();
      this.showSpinner = false;
      this.updated = true;
    });
  }

}
